import __request__ from "routing/request";
export function allFieldTypes(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.views/views/fields", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function byStreams(JSONbody, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.views/views/fields", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function triggerFieldTypePolling(requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.views/views/fields/poll", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
